import React from "react";
import {
  createBrowserRouter,
  RouterProvider,
  Navigate,
} from "react-router-dom";
import Login from "../pages/Login";
import AppLayout from "../components/AppLayout";
import SignUp from "../pages/SignUp";
import AccessDenied from "../pages/AccessDenied";
import { getItem } from "../utils/utils";
import SignOut from "../components/SignOut";
import PageNotFound from "../pages/PageNotFound";
// import EventTag from "../pages/EventTag";
import {
  ACCESSDENIED,
  BASE,
  EVENTPATH,
  EVENTTAGPATH,
  FORGOTPASSWORD,
  GROUPPATH,
  LOGINPATH,
  RESETPASSWORD,
  ROLESPATH,
  SIGNOUTPATH,
  SIGNUPPATH,
  USERSPATH,
  RANKPATH,
  MYPROFILE,
  USERANALYTICSPATH,
  MANDATORYMESSAGEDASHBOARD,
  EVENTMESSAGEDASHBOARD,
  AISUMMARYREPORT,
  ALLMESSAGESPATH,
  RIOPATH,
} from "./routePaths";
import Roles from "../pages/Roles";
import Users from "../pages/Users";
import Dashboard from "../pages/Dashboard";
import ForgotPassword from "../pages/ForgotPassword";
import ResetPassword from "../pages/ResetPassword";
import GroupsPage from "../pages/Groups";
import EventsPage from "../pages/Events";
import Ranks from "../pages/Ranks";
import MyProfile from "../pages/myProfile";
import UserAnalytics from "../pages/UserAnalytics";
import MandatoryMessageDashboard from "../pages/mandatoryMessageDashboard";
import EventMessageDashboard from "../pages/eventMessageDashboard";
import AiSummaryReport from "../pages/AiSummaryReport";
import AllMessages from "../pages/AllMessages";
import AssemblyConstituency from "../pages/AssemblyConstituency";
import RIO from "../pages/RIO";

const AuthWrapper = ({ children }: { children: React.ReactNode }) => {
  const token = getItem("token");
  if (!token) {
    return <Navigate to="/login" replace />;
  }
  return <>{children}</>;
};

const router = createBrowserRouter([
  {
    path: LOGINPATH,
    element: <Login />,
  },
  {
    path: SIGNUPPATH,
    element: <SignUp />,
  },
  {
    path: SIGNOUTPATH,
    element: <SignOut />,
  },
  {
    path: FORGOTPASSWORD,
    element: <ForgotPassword />,
  },
  {
    path: RESETPASSWORD,
    element: <ResetPassword />,
  },
  {
    path: BASE,
    element: (
      <AuthWrapper>
        <AppLayout />
      </AuthWrapper>
    ),
    children: [
      {
        path: BASE,
        element: (
          <AuthWrapper>
            <Dashboard />
          </AuthWrapper>
        ),
      },
      // {
      //   path: EVENTTAGPATH,
      //   element: (
      //     <AuthWrapper>
      //       <EventTag />
      //     </AuthWrapper>
      //   ),
      // },
      {
        path: RANKPATH,
        element: (
          <AuthWrapper>
            <Ranks />
          </AuthWrapper>
        ),
      },
      {
        path: ROLESPATH,
        element: (
          <AuthWrapper>
            <Roles />
          </AuthWrapper>
        ),
      },
      {
        path: USERSPATH,
        element: (
          <AuthWrapper>
            <Users />
          </AuthWrapper>
        ),
      },
      // {
      //   path: CREATEUSER,
      //   element: (
      //     <AuthWrapper>
      //       <CreateUsers mode='create' />
      //     </AuthWrapper>
      //   ),
      // },
      {
        path: MANDATORYMESSAGEDASHBOARD,
        element: (
          <AuthWrapper>
            <MandatoryMessageDashboard />
          </AuthWrapper>
        ),
      },
      {
        path: EVENTMESSAGEDASHBOARD,
        element: (
          <AuthWrapper>
            <EventMessageDashboard />
          </AuthWrapper>
        ),
      },
      {
        path: AISUMMARYREPORT,
        element: (
          <AuthWrapper>
            <AiSummaryReport />
          </AuthWrapper>
        ),
      },
      {
        path: MYPROFILE,
        element: (
          <AuthWrapper>
            <MyProfile />
          </AuthWrapper>
        ),
      },
      // {
      //   path: EDITUSER,
      //   element: (
      //     <AuthWrapper>
      //       <CreateUsers />
      //     </AuthWrapper>
      //   ),
      // },
      {
        path: GROUPPATH,
        element: (
          <AuthWrapper>
            <GroupsPage />
          </AuthWrapper>
        ),
      },
      {
        path: EVENTPATH,
        element: (
          <AuthWrapper>
            <EventsPage />
          </AuthWrapper>
        ),
      },
      {
        path: USERANALYTICSPATH,
        element: (
          <AuthWrapper>
            <UserAnalytics />
          </AuthWrapper>
        ),
      },
      {
        path: ALLMESSAGESPATH,
        element: (
          <AuthWrapper>
            <AllMessages />
          </AuthWrapper>
        ),
      },
      {
        path: RIOPATH,
        element: (
          <AuthWrapper>
            <RIO />
          </AuthWrapper>
        ),
      },
    ],
  },
  {
    path: ACCESSDENIED,
    element: <AccessDenied />,
  },
  {
    path: "*",
    element: <PageNotFound />,
  },
]);

const Routes = () => {
  return <RouterProvider router={router}></RouterProvider>;
};

export default Routes;
